import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Gap } from '@alfalab/core-components/gap';
import { PureCell } from '@alfalab/core-components/pure-cell';
import { Typography } from '@alfalab/core-components/typography';
import { useWidgetContext } from '../../../hooks/use-widget-context';
import styles from './index.module.css';
const phoneNumbersInfo = [
    {
        phone: '+7 495 788-88-78',
        text: 'Для Москвы и Московской области',
        metric: 'OTHER_CONTACTS_CALL_MOSCOW',
        testId: 'other-contacts-call-moscow',
    },
    {
        phone: '8 800 200-00-00',
        text: 'Для звонков по России',
        metric: 'OTHER_CONTACTS_CALL_ALL',
        testId: 'other-contacts-call-all',
    },
];
export const PhoneInfo = () => {
    const { trackInAnalytics, platform } = useWidgetContext();
    const handleAnalytics = (metric) => () => {
        trackInAnalytics(metric);
    };
    return (_jsx(React.Fragment, { children: phoneNumbersInfo.map((item) => (_jsx(PureCell, { tag: 'div', direction: 'horizontal', className: styles.pureCell, onClick: handleAnalytics(item.metric), dataTestId: item.testId, children: _jsx(PureCell.Content, { children: _jsxs(PureCell.Main, { children: [_jsx(Typography.Text, { view: platform === 'mobile' ? 'primary-medium' : 'primary-large', weight: 'medium', children: item.phone }), _jsx(Gap, { direction: 'vertical', size: '2xs' }), _jsx(Typography.Text, { view: 'primary-small', color: 'secondary', children: item.text }), _jsx(Gap, { direction: 'vertical', size: 's' })] }) }) }, item.phone))) }));
};
